import { render, staticRenderFns } from "./UsersDashboard.vue?vue&type=template&id=c2807eb8&"
import script from "./UsersDashboard.vue?vue&type=script&lang=js&"
export * from "./UsersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UsersDashboard.vue?vue&type=style&index=0&id=c2807eb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports